<template>
  <div class="set-price-value">
    <div class="set-price-value__container">
      <div class="set-price-value__price-input">
        <p class="error my-1" v-if="priceError != ''">
          <span>{{ priceError }}</span>
          <span class="error__attention"></span>
        </p>
        <div class="input-container">
          <input
            class="set-price-value__input input form-control"
            inputmode="decimal"
            id="setPriceValue"
            type="text"
            placeholder="Skriv din pris her *"
            v-model.trim="priceTempValue"
            @blur="
              handleNumberPresentation({
                varName: 'priceValue',
                varTempName: 'priceTempValue',
                prepareForPresentation: true,
                postfix: 'kr.',
                separateBythousands: true,
                isInteger: true,
              })
            "
            @focus="
              handleNumberPresentation({
                varName: 'priceValue',
                varTempName: 'priceTempValue',
              })
            "
          />
          <label class="user__input-label control-label" for="setPriceValue"
            >Salgspris</label
          >
        </div>
      </div>

      <div
        class="set-price-value__checkbox-container"
        v-if="productTypeId == 2 || productTypeId == 6"
      >
        <div class="set-price-value__checkbox-container-vertical">
          <div class="checkbox checkbox--highlight" v-if="productTypeId == 2">
            <input
              aria-hidden="true"
              type="checkbox"
              :id="'set-price-value-' + _uid + '-charge'"
              v-model="taxIncluded"
              checked
            />
            <label
              :for="'set-price-value-' + _uid + '-charge'"
              class="set-price-value__checkbox-label"
            >
              <span class="set-price-value__checkbox-text"
                >Med reg. afgift&nbsp;</span
              >
              <span class="input-visual"></span>
            </label>
          </div>
          <div class="checkbox checkbox--highlight" v-if="productTypeId == 6">
            <input
              type="checkbox"
              :id="'set-price-value-' + _uid + '-tax'"
              v-model="vatIncluded"
              aria-hidden="true"
              checked
            />
            <label
              :for="'set-price-value-' + _uid + '-tax'"
              class="set-price-value__checkbox-label"
            >
              <span class="set-price-value__checkbox-text">Med moms</span>
              <span class="input-visual"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NumberPresentationFunctions from '@components/Shared/NumberPresentationFunctions.vue'

export default {
  mixins: [NumberPresentationFunctions],
  components: {},
  props: {
    eventBus: { default: null, type: Object },
    productTypeId: { default: 0, type: Number },
    initialPrice: {
      default: () => {
        return {}
      },
      type: Object,
    },
  },
  data() {
    return {
      priceValue: '',
      priceTempValue: '',
      taxIncluded: true,
      vatIncluded: true,
      priceError: '',
      setPriceTimeout: 0,
    }
  },
  methods: {
    emitData(priceData) {
      this.eventBus.emit('set-price-value-change', priceData)
    },
    getPrice() {
      const priceAsNumber = Number(this.priceValue)
      if (isNaN(priceAsNumber)) {
        this.priceError =
          'Prisen skal angives som heltal uden bogstaver og specialtegn'
        return null
      } else {
        this.priceError = ''
        return priceAsNumber
      }
    },
    isValid() {
      // Kaldet her kontrollerer om prisen er angivet som NaN
      this.getPrice()
      // Ovenstående kald tager ikke højde for et tomt inputfelt - derfor nedenstående
      if (this.priceValue === '') {
        this.priceError = 'Indtast den ønskede salgspris'
      }

      if (this.priceError) return false

      return true
    },
  },
  watch: {
    priceValue() {
      const priceObj = {
        price: this.getPrice(),
        isRegistrationTaxIncluded: this.taxIncluded,
        isVatIncluded: this.vatIncluded,
      }

      this.emitData(priceObj)
    },
    taxIncluded() {
      const priceObj = {
        price: this.getPrice(),
        isRegistrationTaxIncluded: this.taxIncluded,
        isVatIncluded: this.vatIncluded,
      }

      this.emitData(priceObj)
    },
    vatIncluded() {
      const priceObj = {
        price: this.getPrice(),
        isRegistrationTaxIncluded: this.taxIncluded,
        isVatIncluded: this.vatIncluded,
      }

      this.emitData(priceObj)
    },
  },
  created() {
    if (this.initialPrice && this.initialPrice.price) {
      this.priceTempValue = this.initialPrice.price.toString() // Sætter temp værdien, da den egentlige værdi sættes i handleNumberPresentation funktionen
      this.handleNumberPresentation({
        varName: 'priceValue',
        varTempName: 'priceTempValue',
        prepareForPresentation: true,
        postfix: 'kr.',
        separateBythousands: true,
        isInteger: true,
      })
    }
    this.taxIncluded = this.initialPrice.taxIncluded
    this.vatIncluded = this.initialPrice.vatIncluded
  },
}
</script>

<style lang="scss">
@import 'SetPriceValue.scss';
</style>
